import { useTranslation } from 'react-i18next';
import { Card } from './ui/card';
import { cn } from '@/lib/utils';
import { QuizQuestion as QuizQuestionType } from '@/lib/quiz-data';

interface QuizQuestionProps {
  question: QuizQuestionType;
  selectedOption: string | null;
  onSelectOption: (optionId: string) => void;
  questionNumber: number;
  totalQuestions: number;
}

export const QuizQuestion = ({
  question,
  selectedOption,
  onSelectOption,
  questionNumber,
  totalQuestions
}: QuizQuestionProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="text-center space-y-2">
        <p className="text-sm text-muted-foreground">
          {t('quiz.questionOf', { current: questionNumber, total: totalQuestions })}
        </p>
        <h2 className="text-2xl font-bold text-foreground">
          {t(question.question)}
        </h2>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {question.options.map((option) => (
          <Card
            key={option.id}
            className={cn(
              'p-6 cursor-pointer transition-all hover:scale-105 hover:shadow-lg',
              selectedOption === option.id
                ? 'border-primary border-2 bg-primary/5'
                : 'border-border hover:border-primary/50'
            )}
            onClick={() => onSelectOption(option.id)}
          >
            <div className="flex flex-col items-center text-center space-y-3">
              <span className="text-5xl">{option.icon}</span>
              <p className="font-medium text-sm">
                {t(option.label)}
              </p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
